<template lang="pug">
.amount
  div(v-if="hasAmount")
    span.font-medium.danger500--text(v-if="item.error") {{ calculatedAmount | displayPrice }}
    span(v-else) {{ calculatedAmount | displayPrice }}
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasAmount() {
      return this.item.quantity > 0 && this.item.rate >= 0
    },
    calculatedAmount() {
      return this.item.quantity * this.item.rate
    }
  },
};
</script>

<style lang="scss" scoped>
</style>